/**
 * Types shared by the Onboarding Ramp tab and its sub-components.
 *
 * Deliberately kept separate from configTypes.ts (which covers the org/dept-scoped
 * config shell) because the ramp tab has its own internal shape.
 */

export interface ItemWeeksConfig {
  preferred: number;
  training: number;
  certification: number;
}

/**
 * The full configuration for one location's onboarding ramp.
 * This is the shape the tab and its cards work with locally —
 * it gets mapped from / to the API DTO in OnboardingRampTab.
 */
export interface LocationOnboardingConfig {
  location: string;
  /** Backend scope: a location without its own saved ramp is `INHERITED` from the national ramp. */
  scopeType?: 'NATIONAL' | 'LOCATION_OVERRIDE' | 'INHERITED';
  onboardingWeeks: number;
  /** Three milestone weeks in strictly ascending order, e.g. [4, 8, 12]. */
  milestoneWeeks: [number, number, number];
  itemWeeks: ItemWeeksConfig;
  /** Per-metric target arrays, one value per onboarding week. */
  targets: Record<string, number[]>;
  updatedBy?: string;
  updatedOn?: string;
}

/** Metric descriptor for the weekly target table. */
export interface MetricConfig {
  key: string;
  label: string;
  unit: string;
  step: number;
}

/**
 * The five metrics shown in the Weekly Pulse Check Target Glidepath table.
 * Order and keys must match the API field names used in AdminTargetWeekItem /
 * RampSaveRequestDTO targets map.
 */
export const METRICS_CONFIG: MetricConfig[] = [
  { key: 'DPS',          label: 'DPS Target',          unit: '%',         step: 0.1  },
  { key: 'KU',           label: 'KU Target',           unit: '%',         step: 0.1  },
  { key: 'Gap Time',     label: 'Gap Time Target',     unit: 'min',       step: 0.1  },
  { key: 'BPA',          label: 'BPA Target',          unit: 'boxes/hr',  step: 0.01 },
  { key: 'Cases Picked', label: 'Cases Picked Target', unit: 'cases/day', step: 1    },
];
